
	import {
		Component,
		Prop,
		Vue,
		Watch,
		Ref
	} from "vue-property-decorator";
	import Cookies from "js-cookie";
	import dragVerify from "vue-drag-verify";
	import 'font-awesome/css/font-awesome.min.css'
	import Loading from "../../components/Loading.vue";
	import HeaderLayout from "./Modules/Components/Header.vue";
	import Footer from "../../components/Footer.vue";

	import {
		PhoneRegExp
	} from "@/contants/regExp";
	import {
		IMeetingInfo
	} from "@/contants/current";
	import {
		ISendMsg,
		IMobileReg
	} from "@/api/modules/signup/index.dto";

	@Component({
		components: {
			HeaderLayout,
			Footer,
			Loading,
			dragVerify
		},
	})
	export default class signUpLogin extends Vue {
		/**public $refs!: {
		  Verify: dragVerify
		};*/

		private flags = {
			showLoading: false,
			getCode: true,
		};
		private m: string = "";
		private bannerSrc: string = "";
		private meetingTitle: string = "";

		private ruleForm = {
			phone: "",
			phoneCode: "",
		};
		private title: string = "登录";
		private sendAuthCode: boolean = true; //是否显示倒计时
		private authTime: number = 0;
		private clickedSendAuthCode: boolean = false; //是否可以获取验证码
		private smsCode: boolean = true;
		private voiceCode: boolean = false;

		private handlerIcon: string = "fa fa-angle-double-right";
		private successIcon: string = "fa fa-check";
		private background: string = "#f3f3f3";
		private progressBarBg: string = "#409EFF";
		private completedBg: string = "#409EFF";
		private handlerBg: string = "#fff";
		private text: string = "请将滑块拖动到右侧完成验证";
		private successText: string = "验证成功";
		private width: number = 450;
		private height: number = 40;
		private textSize: string = "16px";
		private circle: boolean = false;
		private protocol: boolean = false;
		private isPassing: boolean = false;

		private rules = {
			phone: [{
				required: true,
				validator(rule: any, value: number, callback: Function) {
					if (!PhoneRegExp.test(String(value))) {
						callback(new Error("请输入正确手机号"));
					}
					callback();
				},
				trigger: "change",
			}, ],
			phoneCode: [{
					required: true,
					message: "请输入正确的验证码",
					trigger: "blur"
				},
				{
					min: 4,
					max: 4,
					message: "请输入正确的验证码",
					trigger: "change"
				},
			],
		};
		private submit_loading: boolean = false;


		@Watch("ruleForm.phone", {
			immediate: true,
			deep: true
		})
		watchPhone(val: any) {
			if (PhoneRegExp.test(String(val))) {
				this.clickedSendAuthCode = true;
			} else {
				this.clickedSendAuthCode = false;
			}
		}

		created() {
			const {
				m
			} = this.$route.query;
			this.m = String(m);
			this.isLogin();
			this.InitMeetingInfo();
		}
		/**
		 * @description: 获取会议基本信息
		 */
		async InitMeetingInfo() {
			this.flags.showLoading = true;
			let params = {
				m: this.m,
			};
			let res = await IMeetingInfo.InitMeetingInfo(params);

			this.bannerSrc = res.PCBannerImage;
			this.meetingTitle = res.MeetingTitle;
			console.log("会议基本信息", res);
			this.flags.showLoading = false;
		}
		/**
		 * @description:检查用户是否登录报名
		 */
		async isLogin() {
			let params = {
				m: this.m,
			};
			let res = await this.$http.SignUp.CheckMeetingUserSign(params);
			console.log("检查用户是否登录报名", res);
			/**if (res.status == 401) {
			  const { query } = this.$route;
			  this.$router.push({
			    path: "/login",
			    query,
			  });
			}*/
		}



		/**
		 * @description: 开启倒计时， 获取验证码
		 */
		async getAuthCode() {

			if ((this.$refs.Verify as any).isPassing) {
				if (this.flags.getCode) {
					this.sendAuthCode = false;
					this.authTime = 60;
					let timer = setInterval(() => {
						this.authTime--;
						if (this.authTime <= 0) {
							clearInterval(timer);
							this.sendAuthCode = true;
						}
					}, 1000);

					let params: ISendMsg = {
						m: this.m,
						phone: this.ruleForm.phone,
					};
					let resCode = await this.$http.SignUp.SendMsg(params);
					this.flags.getCode = false;

					if (resCode.Code !== 1000) {
						this.sendAuthCode = true;
					}
					this.flags.getCode = true;
				}
			} else {
				this.$message({
					message: "请将滑块拖动到右侧完成验证",
					type: "warning"
				});
			}
		}
		smsCodeFun() {
			this.voiceCode = false
			this.smsCode = true
		}
		voiceCodeFun() {
			this.vioceVal()
		}
		goProtocol() {
				window.open('https://mp.weiqihd.com/msite/site/10697/11140')
		}
		async vioceVal() {
			if (!this.clickedSendAuthCode) {
				this.$message({
					message: "请输入正确手机号",
					type: "warning"
				});
			} else if (!((this.$refs.Verify as any).isPassing)) {
				this.$message({
					message: "请将滑块拖动到右侧完成验证",
					type: "warning"
				});
			} else {
				this.voiceCode = true
				this.smsCode = false
				let params: ISendMsg = {
					m: this.m,
					phone: this.ruleForm.phone,
				};
				const Res = await this.$http.SignUp.SendVioceMsg(params)

				if (Res.Code === 1000) {
					this.$message({
						message: "验证码已发送，请您注意接听陌生号码来电，并记录验证码。",
						type: "success"
					});
				}
			}

		}
		/**
		 * @description: 确认登录
		 */
		submitForm(formName: any) {
			(this.$refs[formName] as any).validate((valid: any) => {
				if (valid) {
					if( this.protocol){
						this.submit_loading = true;
						let params: IMobileReg = {
							m: this.m,
							phone: this.ruleForm.phone,
							code: this.ruleForm.phoneCode,
						};
						
						this.submit(params);
					}else{
						this.$message({
							message: "请同意《用户协议》和《隐私政策》!",
							type: "warning"
						});
					}
					
				} else {
					console.log("error submit!!");
				}
			});
		}

		/**
		 * @description:登录
		 */
		async submit(params: IMobileReg) {
			let res = await this.$http.SignUp.MobileReg(params);
			const {
				accesstoken,
				exp,
				Code
			} = res;
			if (Code === 1000) {
				const inFifteenMinutes = new Date(Number(new Date().getTime()) + exp * 60 * 1000);
				Cookies.set("wqToken", res.accesstoken, {
					expires: inFifteenMinutes,
					path: "/"
				});
				this.$router.push({
					path: "/",
					query: this.$route.query,
				});
			} else {
				this.submit_loading = false;
			}
		}
	}
